const paths = {
  listApiKeys: '/apikeys-management/list',
  consumptionReport: '/apikeys-management/consumption-report'
};

export default paths;
